// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3qSmt","title":"Images45_title__21KtW","images":"Images45_images__2L5Th"};